/* global axios */
import ApiClient from '../ApiClient';

class PilotAssistantPortals extends ApiClient {
  constructor() {
    super('pilot/assistants', { accountScoped: true });
  }

  get({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/portals`);
  }

  create({ assistantId, portalId }) {
    return axios.post(`${this.url}/${assistantId}/portals`, {
      portal_id: portalId,
    });
  }

  delete({ assistantId, id }) {
    return axios.delete(`${this.url}/${assistantId}/portals/${id}`);
  }
}

export default new PilotAssistantPortals();
